/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import striptags from "striptags";
import json_access from "../../../variables/access"

import axios from "axios";
import ErrorJSON from "../../utils/Error";
import { ROOT_URL } from "../../../constants";

class Edit extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      modal: false,
      access:this.props.user.access,
      quota_image: this.props.user.quota_image.toString(),
      quota_video: this.props.user.quota_video.toString(),
      quota_dom: this.props.user.quota_dom.toString(),
    };
  }

  toggle() {
    console.log("toggle");
    this.setState({ modal: !this.state.modal });
  }

  handleChange(e) {
    let nam = e.target.name;
    let val = e.target.value;
    this.setState({ [nam]: striptags(val).toString() });
  }

  handleCheck(value) {
    this.setState((prevState) => {
      const access = prevState.access;
      access.indexOf(value) === -1 ? access.push(value) :  access.splice(access.indexOf(value) , 1);
      return { access: access };
    });
    console.log(this.state)
  }


  handleSubmit(event) {
    event.preventDefault();

    this.setState({ errors: false });

    axios
      .post(`${ROOT_URL}/api/admin/users/edit`, { id: this.props.user._id, ...this.state })
      .then((res) => {
        window.location.reload();
      })
      .catch((err) => {
        if (!err.response || !err.response.data) {
          this.setState({ errors: err.message });
        } else {
          this.setState({ errors: err.response.data });
        }
      });
  }

  render() {
    return (
      <div>
        <Modal centered={true} isOpen={this.state.modal} toggle={this.toggle}>
          <ModalHeader toggle={this.toggle}>Edit quotas</ModalHeader>
          <form onSubmit={this.handleSubmit}>
            <ModalBody>
              {this.state.errors ? (
                <ErrorJSON json={this.state.errors}></ErrorJSON>
              ) : (
                <span></span>
              )}
      
              <div className="mb-1">Access</div>
              <br />
              <FormGroup check inline>
                {Object.keys(json_access).map((access) => {
                  console.log("this.state.access.indexOf(access)", this.state.access.indexOf(access))
         
                  return (     <Label className="mr-3" check>
                  <Input
                    onChange={() => this.handleCheck(access)}
                    type="checkbox"
                    checked={this.state.access.indexOf(access) !== -1}
                  />{" "}
                  {json_access[access].pretty}
                  <span className="form-check-sign">
                    <span className="check"></span>
                  </span>
                </Label>)
                })}
           
                
              </FormGroup>

              <FormGroup>
                <Label for="description">Image quota</Label>
                <Input
                  type="number"
                  name="quota_image"
                  id="image_quota"
                  max="99999"
                  required
                  min="0"
                  value={this.state.quota_image}
                  onChange={this.handleChange}
                  placeholder="Image quota"
                />
              </FormGroup>
              <FormGroup>
                <Label for="description">Video quota</Label>
                <Input
                  type="number"
                  name="quota_video"
                  id="video_quota"
                  required
                  max="99999"
                  value={this.state.quota_video}
                  min="0"
                  onChange={this.handleChange}
                  placeholder="Video quota"
                />
              </FormGroup>
              <FormGroup>
                <Label for="description">HTML quota</Label>
                <Input
                  type="number"
                  name="quota_dom"
                  id="dom_quota"
                  required
                  max="99999"
                  value={this.state.quota_dom}
                  min="0"
                  onChange={this.handleChange}
                  placeholder="HTML quota"
                />
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={this.toggle}>
                Cancel
              </Button>
              <Button color="primary" type="submit">
                Save
              </Button>{" "}
            </ModalFooter>
          </form>
        </Modal>
      </div>
    );
  }
}

export default Edit;
